import React, { useEffect, useState } from "react";
import authApiService from "../services/authServices";
import { useSearchParams } from "react-router-dom";
import User from "../components/PlayerProfile/User";
import UpcomigMatches from "../components/PlayerProfile/UpcomigMatches";
import { jwtDecode } from 'jwt-decode';
import { ThreeDots } from 'react-loader-spinner';
import Inbox from "../components/PlayerProfile/Inbox";

function Playerprofile() {
   const [playerProfileData, setPlayerProfileData] = useState([]);
   const [finalUserId, setFinalUserId] = useState(null);
   const [isLoading, setIsLoading] = useState(true);
   const [bannerStatus, setBannerStatus] = useState({
      isSeasonOpenForRegistration: false,
      hasPaidForSeason: false,
      registeredSeasonName: null,
      isSchedulePosted: false,
   });

   const [searchParams] = useSearchParams();
   const MRId = searchParams.get("userId");

   // Decode token and set finalUserId
   useEffect(() => {
      const token = localStorage.getItem("accessToken");
      const decodedToken = token ? jwtDecode(token) : null;
      const tokenUserId = decodedToken?.userId || null;

      // Prioritize MRId if present
      setFinalUserId(MRId ?? tokenUserId);
   }, [MRId]);

   useEffect(() => {
      if (!finalUserId) {
         setIsLoading(false);
         return;
      }

      const fetchPlayerProfile = async () => {
         try {
            setIsLoading(true);
            const response = await authApiService.get("welcomeGuest", { userId: finalUserId });
            if (response?.data) {
               setPlayerProfileData(response.data);
            }
         } catch (error) {
            console.error("Error fetching player profile data:", error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchPlayerProfile();
   }, [finalUserId]);

   // Banner status for IMAGE A/B/C (city-level + user payment, no division filter)
   useEffect(() => {
      const fetchBannerStatus = async () => {
         try {
            const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
            const cityId = selectedCity?.id;
            if (!cityId) return;

            const token = localStorage.getItem("accessToken");
            const decodedToken = token ? jwtDecode(token) : null;
            const tokenUserId = decodedToken?.userId || null;

            const res = await authApiService.post('homeBannerStatus', {
               userId: tokenUserId ? String(tokenUserId) : null,
               cityId: String(cityId),
            });

            if (res?.code === 200 && res?.data) {
               setBannerStatus({
                  isSeasonOpenForRegistration: res.data.isSeasonOpenForRegistration === true,
                  hasPaidForSeason: res.data.hasPaidForSeason === true,
                  registeredSeasonName: res.data.registeredSeasonName || null,
                  isSchedulePosted: res.data.isSchedulePosted === true,
               });
            }
         } catch (error) {
            console.error('Error fetching banner status:', error);
         }
      };

      fetchBannerStatus();
   }, []);


   return (
      <div className="page-container col-sm-9">
         <style>{`
            .loader-container {
               display: flex;
               justify-content: center;
               align-items: center;
               min-height: 400px;
               width: 100%;
               position: relative;
            }
            #profile .loader-container {
               width: 100%;
               margin: 0 auto;
            }
         `}</style>
         <div id="profile">
            {/* <h2 className="page-title"> Player Profile</h2> */}
            {isLoading ? (
               <div className="loader-container" style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                  <ThreeDots
                     height="80"
                     width="80"
                     radius="9"
                     color="#4fa94d"
                     ariaLabel="three-dots-loading"
                     visible={true}
                  />
               </div>
            ) : (
               <div className="row">
                  <User playerProfileData={playerProfileData} userId={finalUserId} />
                  <UpcomigMatches
                     playerProfileData={playerProfileData}
                     userId={finalUserId}
                     isSeasonOpenForRegistration={bannerStatus.isSeasonOpenForRegistration}
                     hasPaidForSeason={bannerStatus.hasPaidForSeason}
                     registeredSeasonName={bannerStatus.registeredSeasonName}
                     isSchedulePosted={bannerStatus.isSchedulePosted}
                  />
                  <Inbox userId={finalUserId} recipientName={playerProfileData?.fullName || ""} />
               </div>
            )}
         </div>
      </div>
   )
}

export default Playerprofile